import {
	AfterViewInit,
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter,
	HostListener,
	Input,
	OnChanges,
	OnDestroy,
	OnInit,
	Output,
	SimpleChanges,
	ViewChild,
} from '@angular/core';
import { debounceTime, fromEvent, Subscription, take } from 'rxjs';
import { DialogAction, Phrase } from '../../../interfaces/common-interfaces';
import { GameOverlayService } from '../../../services/game-overlay/game-overlay.service';
import { SignialsService } from '../../../services/signals/signials.service';
import { AudioService } from '../../../services/audio/audio.service';
import { GameUiService } from '../../../services/game-ui/game-ui.service';

@Component({
  selector: 'app-nps-dialog',
  templateUrl: './nps-dialog.component.html',
  styleUrl: './nps-dialog.component.scss'
})
export class NpsDialogComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {
	@Input()
	phrases: Phrase[];
	@Input()
	name: string;
	@Input()
	placementInCenter: boolean;
	@Input()
	cssClass?: string;
	@Input()
	odwrotnie?: boolean;
	@Input()
	smooth?: boolean;
	@Output()
	closeDialog: EventEmitter<DialogAction> = new EventEmitter();
	@ViewChild('view', {static: true}) view: ElementRef<HTMLDivElement>;
	@ViewChild('dialog', {static: true}) dialog: ElementRef<HTMLDivElement>;

	currentStep = 0;

	// clicked$: Subscription;

	timeOut;
	// subs: Subscription;

	showCloseButton = true;

	skipSubscription: Subscription;
	constructor(
		private audioService: AudioService,
		private overlay: GameOverlayService,
		private cdr: ChangeDetectorRef,
		private signal: SignialsService,
		private ui: GameUiService,
	) {}
	// В компоненте с UI (не игровым полем)
	@HostListener('touchmove', ['$event'])
	onTouchMove(e: TouchEvent) {
		if (e.touches.length > 1) {
			e.preventDefault(); // Только для UI-элементов
		}
	}

	@HostListener('gesturestart', ['$event'])
	onGestureStart(e: Event) {
		e.preventDefault(); // Блокируем зум на UI
	}
	ngOnInit(): void {
		this.startDialogPhrase();
		this.signal.dialogActive$.next(true);

		this.skipSubscription = this.ui.skipClicked$.pipe(debounceTime(300)).subscribe(click => {
			if (click) {
				this.onCloseClick();
			}
		});
	}
	ngOnDestroy(): void {
		// this.subs.unsubscribe();
		// this.clicked$?.unsubscribe();
		this.signal.dialogActive$.next(false);
		this.skipSubscription.unsubscribe();
		// this.audioService.stopAll();

		const sound = this.phrases[this.currentStep].sound;
		if (sound && Array.isArray(sound)) sound.forEach(s => typeof s === 'string' ? this.audioService.stop(s) : this.audioService.stop(s.name))
		else if (sound) this.audioService.stop(sound);
	}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['phrases'].previousValue && changes['phrases'].currentValue != changes['phrases'].previousValue) {
			this.currentStep = 0;
			setTimeout(() => {
				this.startDialogPhrase();
				this.cdr.detectChanges();
			}, 1000);
		}
  }
	ngAfterViewInit(): void {
		this.view.nativeElement.classList.add('opacity-transition');
		// this.clicked$ = fromEvent(this.view.nativeElement, 'click').subscribe(() => {
			
		// });

		if (this.smooth) {
			this.dialog.nativeElement.classList.add('smooth');
			setTimeout(() => {
				this.dialog.nativeElement.classList.remove('smooth');
			}, 100);
		}
	}

	stopSound() {
		const sound = this.phrases[this.currentStep].sound;
		
		if (sound && Array.isArray(sound)) sound.forEach(s => typeof s === 'string' ? this.audioService.stop(s) : this.audioService.stop(s.name))
		else if (sound) this.audioService.stop(sound);


		this.overlay.stopAnimateSpeaker();
	}
	completed() {
		this.overlay.stopAnimateSpeaker();
		if (this.phrases[this.currentStep+1]) {
			this.currentStep++;
			this.startDialogPhrase();
			// console.log('this.phrases[this.currentStep+1]');
		} else if (this.phrases[this.currentStep].action) {
			// console.log('closed', this.phrases[this.currentStep].action);
			this.closed(this.phrases[this.currentStep].action!);
		}
		this.cdr.detectChanges();
	}

	onCloseClick() {
		const lastPhrase = this.phrases[this.phrases.length - 1]
		if (lastPhrase.action) {
			this.closed(lastPhrase.action);
		}
	}

	startDialogPhrase() {
		if (this.timeOut) {
			clearTimeout(this.timeOut);
			this.timeOut = null;
		}

		const sound = this.phrases[this.currentStep].sound;
		const volume = this.phrases[this.currentStep].volume;

		if (sound && Array.isArray(sound)) sound.forEach(s => typeof s === 'string' ? this.audioService.play(s, {volume}) : this.audioService.play(s.name, {volume: s.volume}))
		else if (sound) this.audioService.playVoice(sound, this.overlay, {volume});

		if (this.phrases[this.currentStep].spines) {
			this.overlay.addSpineToOverlay(this.phrases[this.currentStep].spines!);
		}

		setTimeout(() => {
			this.overlay.startAnimateSpeaker(this.phrases[this.currentStep].animation, false, this.phrases[this.currentStep].endAnimation);
		}, 100);
	}

	closed(action: DialogAction) {
		const sound = this.phrases[this.currentStep].sound;
		
		if (sound && Array.isArray(sound)) sound.forEach(s => typeof s === 'string' ? this.audioService.stop(s) : this.audioService.stop(s.name))
		else if (sound) this.audioService.stop(sound);

		this.overlay.stopAnimateSpeaker()
		this.closeDialog.emit(action);
	}
}
